import styled from 'styled-components';

import { User } from 'modules/graphql/types';
import { getDateTime } from 'modules/templateEditor/common/utils';
import { colors, spacing } from 'ui/theme';
import { UserAction } from './UserAction';

const CREATOR_MODIFIER_CONTENT = {
  modified: 'Modified',
  created: 'Created',
};

export const CREATOR_MODIFIER_SECTION_TEST_ID = 'creator-and-modifier';

const UserActionsContainer = styled.div<{
  $backgroundColor: string;
  $bordered: CreatorAndModifierSectionProps['bordered'];
}>`
  border-radius: ${spacing.half};
  display: flex;
  flex-direction: row;
  background: ${({ $backgroundColor }) => $backgroundColor || `${colors.grey1}`};
  padding: ${spacing.plusHalf};
  gap: ${spacing.plusHalf};
  border: ${({ $bordered }) => ($bordered ? `1px solid ${colors.borderPrimary}` : 'none')};
`;

const PlaceHolder = styled.div`
  display: flex;
  flex: 1;
`;

const UserActions = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: ${spacing.plusHalf};
  flex: 2;
`;

export type CreatorAndModifierSectionProps = {
  children?: JSX.Element;
  creator: User;
  modifier?: User | null;
  createdDate?: string;
  modifiedDate?: string;
  bordered?: boolean;
  backgroundColor?: string;
  variant?: 'default' | 'compact';
};

/**
 * TODO: make this a Core UI component and add storybook stories
 */
export const UserActionsMetadata = ({
  children,
  creator,
  modifier,
  createdDate,
  modifiedDate,
  backgroundColor = '',
  variant = 'default',
  bordered,
}: CreatorAndModifierSectionProps) => {
  return (
    <UserActionsContainer
      $bordered={bordered}
      $backgroundColor={backgroundColor}
      data-test={CREATOR_MODIFIER_SECTION_TEST_ID}
    >
      <UserActions>
        {modifier && (
          <UserAction
            data-test="modifier-detail-row"
            fullName={modifier?.fullName || ''}
            imgUrl={modifier?.avatarUrl || ''}
            date={getDateTime(modifiedDate)}
            title={CREATOR_MODIFIER_CONTENT.modified}
            justify={variant === 'default' ? 'start' : 'space-between'}
          />
        )}

        <UserAction
          fullName={creator?.fullName || ''}
          imgUrl={creator?.avatarUrl || ''}
          date={getDateTime(createdDate)}
          title={CREATOR_MODIFIER_CONTENT.created}
          data-test="creator-detail-row"
          justify={variant === 'default' ? 'start' : 'space-between'}
        />
      </UserActions>
      {variant === 'default' ? children || <PlaceHolder /> : null}
    </UserActionsContainer>
  );
};
